import React from "react";
import ContactForm from "../components/ContactForm";

const ContactUs = () => {
  return (
    <div id="/contactus" style={{height: "60vh"}}>
     
      <ContactForm />
    
    </div>
  );
};

export default ContactUs;
